import { PrivateRotes } from '@/routes/private-rotes.ts';

export const PROFILE_ROUTES = {
  BASE: PrivateRotes.PROFILE,
};
